"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateUserSettings = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var noop_1 = (0, tslib_1.__importDefault)(require("lodash/fp/noop"));
var ViewPreferenceApiService_1 = require("../services/ViewPreferenceApiService");
var useUpdateUserSettings = function () {
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var updateUserSettings = function (settings, onCompleted, onError) {
        if (onCompleted === void 0) { onCompleted = noop_1.default; }
        if (onError === void 0) { onError = noop_1.default; }
        return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var res;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, ViewPreferenceApiService_1.ViewPreferenceApiService.put('/settings/{userId}', {
                                body: {
                                    DataParams: (0, tslib_1.__assign)({}, settings),
                                },
                            }).then(onCompleted, onError)];
                    case 1:
                        res = _a.sent();
                        setLoading(false);
                        return [2 /*return*/, res];
                }
            });
        });
    };
    return [updateUserSettings, loading];
};
exports.useUpdateUserSettings = useUpdateUserSettings;
